import React, {Component} from 'react';
import * as midi from '../js/rpl_midi.js';

class PropertyComponent extends React.Component {

	constructor(props) {
		super(props);

		this.labelText = props.labelText;
		this.propId    = props.propId;
		this.ccNum     = props.ccNum;

		this.state = {
			value: 0,
			disabled: props.disabled
		};
	}

	componentDidMount() {
		if (this.propId !== undefined) {
			midi.addPropertySubscriber(this.propId, this);
		}

		if (this.ccNum !== undefined) {
			midi.addControlChangeSubscriber(this.ccNum, this);
		}
	}

	componentWillUnmount() {
		if (this.propId !== undefined) {
			midi.removePropertySubscriber(this.propId, this);
		}

		if (this.ccNum !== undefined) {
			midi.removeControlChangeSubscriber(this.ccNum, this);
		}
	}
}

export default PropertyComponent;
